import useRead from "../useRead";

const useGetAccountDetails = (callbacks = {}) => {
  const { onSuccess, onError, onSettled } = callbacks;
  
  return useRead({
    url: 'get_profile',
    method: 'GET',
    onSuccess,
    onError,
    onSettled
  });
};

export default useGetAccountDetails;
